import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { Button } from '@mui/material';
import { useHistory } from "react-router-dom";
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';

import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';



import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import { useParams } from "react-router-dom";



export default function RepassarProcedimento({ idOrdemServico, idProcedimentoRepassar, onClose }) {

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode');
        return saved === 'true';
    });

    const themeHelper = {
        bg: darkMode ? "#121212" : "#e9eff3",
        paper: darkMode ? "#1e1e1e" : "#ffffff",
        text: darkMode ? "#ffffff" : "#1a1a1a",
        textSecondary: darkMode ? "#aaaaaa" : "#5a6a7a",
        border: darkMode ? "#333333" : "#d1d9e0",
    };

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode');
            setDarkMode(saved === 'true');
        };

        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
        };
    }, []);




    const [botaoClicado, setBotaoClicado] = useState(false);

    const [usuarios, setUsuarios] = useState([]);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
    const [mensagemExtra, setMensagemExtra] = useState('');

    const salvar = () => {
        // Verifica se o botão já foi clicado
        if (!botaoClicado) {
            // Executa a lógica do clique aqui
            console.log('Botão clicado!');

            // Atualiza o estado para indicar que o botão foi clicado
            setBotaoClicado(true);
            funcaoSalvar();
        }
    };


    const history = useHistory();


    async function funcaoSalvar() {

        let id_usuario_criador = Cookies.get("id_usuario");
        let id_usuario_executor = -1;
        try {

            console.log("cadastrar chamado");



            if (!usuarioSelecionado) {
                setBotaoClicado(false);
                alert("Selecione o Usuário!");
                return;
            } else {
                id_usuario_executor = usuarioSelecionado.id_usuario;
            }


            if (id_usuario_executor <= 0) {
                setBotaoClicado(false);
                alert("Erro interno!");
                return;
            }

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/ordemservico/repassarprocedimento/' + idOrdemServico + "/" + idProcedimentoRepassar + "/" + id_usuario_criador + "/" + id_usuario_executor,
                mensagemExtra, { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Procedimento Repassado");

                onClose();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
                setBotaoClicado(false);
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            setBotaoClicado(false);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }



    const [loading, setLoading] = useState(true);



    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/user/listartodos", {
                headers: headers
            }).then(function (response) {
                setUsuarios(response.data)
                setLoading(false);


            });

        } catch (_err) {
            alert("Erro!");
            console.log("Erro ao listar Procedimentos: " + _err)

        }

    }

    useEffect(() => {




        listar();


    }, []);




    function returnDescricaoUsuario(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\nNome: " + usuario.nome_amigavel + "\nRegiões de Atuação: " + usuario.regiao_cobertura;

        var dados_colaborador = "";

        if (usuario.tipo_associacao === 0) {
            //colaborador
            dados_colaborador += ("\nDepartamentos: " + usuario.colaborador.departamentos.map(departamento => departamento.nome).join(", "));
            dados_colaborador += ("\nCargos: " + usuario.colaborador.cargos.map(cargo => cargo.nome).join(", "));
            dados_colaborador += ("\nFunções: " + usuario.colaborador.funcoes.map(funcao => funcao.nome).join(", "));


        }

        texto += ("\n" + dados_colaborador);


        return texto;
    }


    function handleUsuario(user) {
        setUsuarioSelecionado(user);
    }



    return (
        <div>

            {loading ?
                <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :
                <Grid container spacing={1}
                    alignItems="center"
                    justifyContent="center"
                >






                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{ marginTop: 5 }}
                    >
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                        >

                            <Autocomplete
                                id="select-procedimento-usuario-designado"
                                options={usuarios}

                                getOptionLabel={(usuario) => returnDescricaoUsuario(usuario).replace(/<br \/>/g, '\n')}
                                value={usuarioSelecionado}
                                onChange={(e, v) => handleUsuario(v)}
                                filterOptions={(options, { inputValue }) => {
                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                    return options.filter((solicitante) => {
                                        const cotacaoText = returnDescricaoUsuario(solicitante).toLowerCase();
                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label=" Usuário Executor " multiline minRows={1} />
                                )}
                                renderOption={(option) => (
                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoUsuario(option) }} />
                                )}

                            />
                        </Grid>
                    </Grid>

                    <Grid
                        item xs={12}
                        style={{ paddingTop: 20 }}
                    >
                        <TextField
                            variant="standard"
                            name="mensagem"
                            label="Mensagem"
                            required
                            id="mensagem"
                            value={mensagemExtra}
                            onChange={(e) => setMensagemExtra(e.target.value)}
                            fullWidth
                            multiline
                            minRows={2}
                        />

                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={12}
                    >
                        <Button style={{ margin: 2 }}
                            variant="contained"
                            color="primary"
                            onClick={salvar}
                            disabled={botaoClicado}
                        > Salvar  </Button>
                    </Grid>
                </Grid>


            }
        </div>

    );
}


